import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/@dialectlabs/react-ui/dist/index.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/@velocity-exchange/common/lib/clients/DlobWebsocketClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/ui/node_modules/@vercel/analytics/dist/react/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--next-font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadResources"] */ "/vercel/path0/ui/src/app/preload-resources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/AppWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/Pwa/PwaRegistrar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/styles/index.css");
